export const headerConstants = {
  AUTO_HEADER_KEY: 'x-app-name',
  AUTO_HEADER_VALUE: 'carbon',
}
